import { GateActivity } from 'CustomHooks/usePinAuth';

/** The lock only opens the day's open/close dialog. */
export const dayDialogActivity = (date: string): GateActivity => ({
  action: 'day.reservationsDialog',
  category: 'form',
  targets: [{ type: 'day', id: date }],
});

export const terraceActivity = (date: string, terraceOpen?: boolean): GateActivity => ({
  action: terraceOpen ? 'terrace.close' : 'terrace.open',
  targets: [{ type: 'day', id: date }],
});
